import { Link } from "react-router-dom";
import { Diamond, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/motion";
import { CONTACT, waLink } from "@/data/site";

export default function MineralCard({ mineral, index = 0, tall = false }) {
  return (
    <Reveal delay={(index % 3) * 0.1} className="h-full">
      <article
        data-testid={`mineral-card-${mineral.id}`}
        className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-navy-900 transition-[border-color,box-shadow] duration-500 hover:border-gold/40 hover:shadow-[0_24px_80px_-24px_rgba(212,175,55,0.25)]"
      >
        <div className={`relative overflow-hidden ${tall ? "h-80" : "h-60"}`}>
          <img
            src={mineral.image}
            alt={`${mineral.name} ore`}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.06]"
          />
          <div className="pointer-events-none absolute inset-0 spotlight opacity-70 transition-opacity duration-700 group-hover:opacity-100" />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-900/20 to-transparent" />
          <span className="absolute left-5 top-5 rounded-full border border-gold/30 bg-navy-950/60 px-3 py-1 text-[11px] uppercase tracking-[0.25em] text-gold backdrop-blur-md">
            {mineral.symbol}
          </span>
        </div>
        <div className="flex flex-1 flex-col p-7">
          <h3 className="font-serif text-2xl text-slate-50 transition-colors duration-300 group-hover:text-gold-light">
            {mineral.name}
          </h3>
          <p className="mt-1 text-[11px] uppercase tracking-[0.3em] text-gold/80">{mineral.tagline}</p>
          <p className="mt-4 text-sm leading-relaxed text-slate-400">{mineral.description}</p>
          <ul className="mt-5 space-y-2">
            {mineral.specs.map((s) => (
              <li key={s} className="flex items-center gap-2.5 text-xs uppercase tracking-[0.18em] text-slate-500">
                <Diamond className="h-2 w-2 text-gold/70" fill="currentColor" /> {s}
              </li>
            ))}
          </ul>
          <div className="mt-auto pt-6">
            <a
              href={waLink(CONTACT.phones[1].wa, `Hello Tuskers Grey Investments, I'm enquiring about ${mineral.name}.`)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`mineral-enquire-${mineral.id}`}
              className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-gold transition-colors hover:text-gold-light"
            >
              Enquire on WhatsApp <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </div>
      </article>
    </Reveal>
  );
}
